import { any, arrayOf, string } from 'prop-types';
import React, { useContext, useEffect } from 'react';
import FormContext from '../FormContext';

const connectSectionToContext = Section => {
  const MemoizedSection = React.memo(Section);

  const ResultSection = (props) => {
    const {
      data: parentData, errors: parentErrors, onChange,
      validate, resetData, resetErrors, ...formContext
    } = useContext(FormContext);

    const data = parentData[props.name];
    const errors = parentErrors[props.name];

    useEffect(() => {
      if (!data && props.initialData) {
        onChange(props.name, props.initialData);
      }
    }, [data, props.initialData, props.name, onChange]);

    return (
      <MemoizedSection
        {...props}
        data={data}
        errors={errors}
        onChange={onChange}
        {...formContext}
      />
    );
  };

  ResultSection.propTypes = {
    name: string.isRequired,
    initialData: arrayOf(any)
  };

  ResultSection.defaultProps = {
    initialData: undefined
  };

  /* istanbul ignore next */
  ResultSection.displayName = `FormContext(${Section.displayName || Section.name || 'Component'})`;

  return ResultSection;
};

export default connectSectionToContext;
